import {useTranslation} from "react-i18next";
import TableProgramming from "./TableProgramming";
import {useState, useEffect} from "react";
import axiApi from "ApiCaller";

const TabProgramming = ({item}) => {
    const [_Tc] = useTranslation("choices");
    const [itemsShow, setItemsShow] = useState([]);

    useEffect(() => {
        if (itemsShow.length === 0) {
            axiApi
                .post("/api/distribution/static/route/programmings/", {
                    id: item.id,
                })
                .then((resp) => {
                    if (resp.data.status) {
                        setItemsShow([...resp.data.items]);
                    } else {
                        resp.data.message && console.error(resp.data.message);
                    }
                })
                .catch((error) => {});
        }
    }, []);

    return <TableProgramming itemsShow={itemsShow} />;
};

export default TabProgramming;
